import React from 'react';
import {Route} from 'react-router';
import {usePingAuthContext} from './ping/PingAuthProvider';
import {PingAuthStatus} from './ping/types/PingAuthStatus';

export const PrivateRoute = ({component: Component, path, ...rest}) => {
    const {logIn, status} = usePingAuthContext();

    if (status === PingAuthStatus.LOGGED_IN) {
        return <Route path={path} render={(props) => <Component {...props} />} {...rest} />;
    }
    if (status === PingAuthStatus.NOT_LOGGED_IN || status === PingAuthStatus.ERROR) {
        logIn();
        return null;
    }

    return null;
};
